var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11.125,
    viewBox: "0 0 13 11.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dislike",
    d: "M8.5,1A3.489,3.489,0,0,0,6,2.05,3.5,3.5,0,0,0,0,4.5C0,6.433,2,8,6,11c4-3,6-4.567,6-6.5A3.5,3.5,0,0,0,8.5,1Z",
    transform: "translate(0.5 -0.5)",
    fill: "none",
    stroke: "#a7b6b8",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.630cdc2bbd888a435d27051edbb327e8.svg";
export { ForwardRef as ReactComponent };